<template>
  <div style="height: 100vh; width: 100%">
    <div class="header">
      <div class="title">往圣企业端后台</div>
      <div class="title2">
        尊敬的"{{
        this.$store.state.supUser.sup_username
        }}"用户，欢迎您登录往圣健康科技后台管理系统！版本日期：V2026-06-10
      </div>
      <div class="tuichuBtn" @click="tuichuBtn">
        <el-tooltip class="item" effect="dark" content="退出登录" placement="bottom">
          <el-button>
            <i class="el-icon-setting"></i>
          </el-button>
        </el-tooltip>
      </div>
    </div>
    <div class="dome">
      <!-- 导航栏 -->
      <div class="menu">
        <el-menu
          router
          :default-active="nextMenuActive"
          :unique-opened="true"
          style="width: 200px; border-right: none"
          background-color="#304156"
          text-color="#fff"
          active-text-color="#ffd04b"
        >
          <el-submenu :index="item.value" v-for="(item, index) in filterArr" :key="index">
            <template slot="title">
              <i :class="item.icon"></i>
              <span>{{ item.name }}</span>
            </template>
            <el-menu-item-group v-for="(item2, index) in item.nextMenu" :key="index">
              <el-menu-item :index="item2.link" @click="nextMenu(item2.link)">{{ item2.name }}</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </div>
      <div class="right-box">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
import { loginOut } from "../services/system/userServices";
export default {
  created() {
    /* 导航默认高亮 */
    if (localStorage.getItem("nextMenuActive")) {
      this.nextMenuActive = localStorage.getItem("nextMenuActive");
    }
  },
  data() {
    return {
      nextMenuActive: "", //默认选中
      menuArr: [
        {
          id: 1,
          name: "系统管理",
          value: "1",
          roleId: 0,
          icon: "el-icon-user-solid",
          nextMenu: [
            {
              id: 1,
              name: "账号设置",
              link: "/system/admin"
            },
            {
              id: 2,
              name: "意见反馈",
              link: "/system/fankui"
            },
            {
              id: 3,
              name: "数据面板-注册用户",
              link: "/system/dashboard"
            },
            {
              id: 4,
              name: "数据面板-活跃用户",
              link: "/system/dashboard_1"
            },
            {
              id: 5,
              name: "数据面板-地区用户",
              link: "/system/dashboard_2"
            }
          ]
        },
        {
          id: 2,
          name: "小程序配置",
          value: "2",
          roleId: 0,
          icon: "el-icon-s-goods",
          nextMenu: [
            {
              id: 3,
              name: "问答欢迎语",
              link: "/config/answer"
            },
            {
              id: 2,
              name: "用户及会员列表",
              link: "/config/vipUser"
            },
            {
              id: 0,
              name: "商城轮播图",
              link: "/config/banner"
            },
            {
              id: 1,
              name: "个人中心配置",
              link: "/config/pageConfig"
            },
            {
              id: 5,
              name: "临床指南",
              link: "/doctor/clinicalGuidelines"
            }
          ]
        },
        {
          id: 11,
          name: "柜门管理",
          value: "11",
          roleId: 0,
          icon: "el-icon-s-goods",
          nextMenu: [
            {
              id: 0,
              name: "柜子列表",
              link: "/openBox/boxList"
            },
            {
              id: 1,
              name: "开柜记录",
              link: "/openBox/openRecord"
            }
          ]
        },
        {
          id: 15,
          name: "血压测量仪管理",
          value: "15",
          roleId: 0,
          icon: "el-icon-s-goods",
          nextMenu: [
            {
              id: 0,
              name: "血压测量仪列表",
              link: "/instrument/list"
            },
            {
              id: 1,
              name: "支付记录",
              link: "/instrument/order"
            }
          ]
        },
        {
          id: 10,
          name: "预约上门模块",
          value: "10",
          roleId: 0,
          icon: "el-icon-s-goods",
          nextMenu: [
            {
              id: 1,
              name: "护士信息维护",
              link: "/appointment/nurse"
            },
            {
              id: 2,
              name: "预约地址维护",
              link: "/appointment/address"
            },
            {
              id: 2,
              name: "预约订单",
              link: "/appointment/nurseOrder"
            }
          ]
        },
        {
          id: 3,
          name: "问答模块",
          value: "3",
          roleId: 0,
          icon: "el-icon-printer",
          nextMenu: [
            {
              id: 0,
              name: "用户档案",
              link: "/answers/userArchives"
            },
            {
              id: 1,
              name: "病种管理",
              link: "/answers/goodkinds"
            },
            {
              id: 2,
              name: "全部问诊记录",
              link: "/answers/chatList"
            }
            // {
            //   id: 3,
            //   name: "全部问诊记录",
            //   link: "/answers/chatList_all"
            // }
          ]
        },
        {
          id: 4,
          name: "检测模块",
          value: "4",
          roleId: 0,
          icon: "el-icon-printer",
          nextMenu: [
            {
              id: 1,
              name: "检测种类信息配置",
              link: "/niaojian/goodkinds"
            },
            {
              id: 2,
              name: "机器检测",
              link: "/niaojian/robotOrder"
            },
            {
              id: 3,
              name: "机构检测",
              link: "/niaojian/organizationOrder"
            },
            {
              id: 4,
              name: "人工录入检测数据",
              link: "/niaojian/handResult"
            }
          ]
        },
        {
          id: 5,
          name: "商城模块",
          value: "5",
          roleId: 0,
          icon: "el-icon-s-goods",
          nextMenu: [
            {
              id: 1,
              name: "商品分类管理",
              link: "/mall/goodkinds"
            },
            {
              id: 2,
              name: "商品中心",
              link: "/mall/goods"
            },
            {
              id: 3,
              name: "订单管理",
              link: "/mall/order"
            }
          ]
        },
        {
          id: 12,
          name: "贴吧",
          value: "12",
          roleId: 0,
          icon: "el-icon-printer",
          nextMenu: [
            {
              id: 1,
              name: "帖子审核",
              link: "/tieba/list"
            },
            {
              id: 2,
              name: "评论列表",
              link: "/tieba/comment"
            }
          ]
        },
        {
          id: 14,
          name: "视频科普",
          value: "14",
          roleId: 0,
          icon: "el-icon-printer",
          nextMenu: [
            {
              id: 0,
              name: "视频管理",
              link: "/video/list"
            },
            {
              id: 1,
              name: "评论记录",
              link: "/video/comment"
            },
            {
              id: 2,
              name: "点赞记录",
              link: "/video/likeRecord"
            }
          ]
        },
        {
          id: 13,
          name: "投票活动",
          value: "13",
          roleId: 0,
          icon: "el-icon-printer",
          nextMenu: [
            {
              id: 0,
              name: "活动类型",
              link: "/vote/type"
            },
            {
              id: 3,
              name: "活动参赛宣言",
              link: "/vote/commit"
            },
            {
              id: 1,
              name: "参与活动人员列表",
              link: "/vote/list"
            },
            {
              id: 2,
              name: "点赞记录",
              link: "/vote/record"
            }
          ]
        },
        {
          id: 6,
          name: "营销管理",
          value: "6",
          roleId: 0,
          icon: "el-icon-printer",
          nextMenu: [
            {
              id: 5,
              name: "积分变动记录",
              link: "/marketing/moneyRecord"
            },
            {
              id: 2,
              name: "销售推广记录",
              link: "/marketing/vipUser"
            },
            {
              id: 1,
              name: "会员福利设置", //会员购买价格,注册是否自动发送优惠券
              link: "/marketing/vipConfig"
            },
            // {
            //   id: 3,
            //   name: "优惠券列表",
            //   link: "/marketing/couponList"
            // },
            {
              id: 4,
              name: "佣金管理",
              link: "/marketing/bonus"
            },
            {
              id: 6,
              name: "卡券生成",
              link: "/couponCard/create"
            }
          ]
        },
        {
          id: 7,
          name: "门店账号",
          value: "7",
          roleId: 1,
          icon: "el-icon-printer",
          nextMenu: [
            {
              id: 1,
              name: "门店订单",
              link: "/mall/order"
            },
            {
              id: 2,
              name: "佣金记录",
              link: "/marketing/bonus"
            }
          ]
        },
        {
          id: 8,
          name: "检测机构账号",
          value: "8",
          roleId: 2,
          icon: "el-icon-printer",
          nextMenu: [
            {
              id: 1,
              name: "送检管理",
              link: "/niaojian/organizationOrder"
            },
            {
              id: 2,
              name: "佣金记录",
              link: "/marketing/bonus"
            }
          ]
        },
        {
          id: 9,
          name: "医生账号",
          value: "9",
          roleId: 3,
          icon: "el-icon-printer",
          nextMenu: [
            {
              id: 1,
              name: "问诊大厅",
              link: "/answers/chatList"
            },
            {
              id: 2,
              name: "我的问答订单",
              link: "/doctor/myChatList"
            },
            {
              id: 3,
              name: "患者购买记录",
              link: "/mall/order"
            },
            {
              id: 4,
              name: "佣金记录",
              link: "/marketing/bonus"
            },
            {
              id: 5,
              name: "临床指南",
              link: "/doctor/clinicalGuidelines"
            },
            {
              id: 6,
              name: "人工录入检测数据",
              link: "/niaojian/handResult"
            }
          ]
        },
        {
          id: 10,
          name: "客服账号",
          value: "10",
          roleId: 5,
          icon: "el-icon-printer",
          nextMenu: [
            {
              id: 1,
              name: "问诊大厅",
              link: "/answers/chatList"
            },
            {
              id: 2,
              name: "危急重症",
              link: "/answers/danger"
            },
            {
              id: 3,
              name: "手术",
              link: "/answers/operation"
            },
            {
              id: 4,
              name: "服务更新",
              link: "/answers/lack"
            }
          ]
        },
        //微信通知
        {
          id: "14",
          name: "微信通知服务",
          roleId: 0,
          icon: "el-icon-s-comment",
          routerName: "SendService",
          nextMenu: [
            {
              id: "14-1",
              name: "消息模版配置",
              routerName: "SendTemplate",
              link: "/sendService/sendTemplate"
            },
            {
              id: "14-2",
              name: "公众号用户",
              routerName: "SendUser",
              link: "/sendService/sendUser"
            },
            {
              id: "14-3",
              name: "发送记录",
              routerName: "SendRecord",
              link: "/sendService/sendRecord"
            }
          ]
        }
      ],
      num: "" //消息通知数量
    };
  },
  computed: {
    // 导航权限判断
    filterArr() {
      // if (this.$store.state.supUser.roleId == 0) {
      //   return this.menuArr;
      // } else {
      //   return this.menuArr.filter(
      //     (item) => item.roleId == this.$store.state.supUser.roleId
      //   );
      // }
      return this.menuArr.filter(
        item => item.roleId == this.$store.state.supUser.roleId
      );
    }
  },

  methods: {
    tuichuBtn() {
      loginOut().then(resp => {
        this.$message({
          type: "success",
          message: "已退出登录!"
        });
        this.$router.push({ name: "Login" });
      });
    },
    nextMenu(link) {
      console.log(link);
      this.nextMenuActive = link;
      localStorage.setItem("nextMenuActive", link);
    }
  }
};
</script>

<style scoped>
.header {
  position: relative;
  height: 60px;
  background: #fff;
  /* display: flex; */
  line-height: 60px;
  /* outline: 1px solid rgb(230, 230, 230); */
  display: flex;
  background-color: #304156;
}

.header > .title {
  margin-left: 20px;
  font-weight: 600;
  /* border:1px solid red; */
  letter-spacing: 3px;
  color: #cacaca;
}

.header > .title2 {
  margin: 0 auto;
  font-weight: 500;
  /* border:1px solid red; */
  letter-spacing: 1px;
  color: #4b70d8;
  position: relative;
}

/* 退出登录 */
.tuichuBtn {
  position: absolute;
  right: 20px;
}

.dome {
  height: calc(100vh - 60px);
  background: rgba(255, 255, 255, 0.699);
  display: flex;
}

.dome > .menu {
  width: 200px;
  background: #304156;
  /* border: 1px solid red */
  overflow: auto;
  overflow-x: hidden;
}

.right-box {
  width: calc(100% - 200px);
  /* border: 1px solid red; */
}

.el-menu-item.is-active {
  background-color: rgba(27, 36, 51, 0.76) !important;
}
</style>
